"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dissoc = void 0;
function dissoc(objOrK, k) {
    if (typeof objOrK === 'string') {
        return function curriedDissoc(obj) {
            return dissoc(obj, objOrK);
        };
    }
    else {
        const _a = objOrK, _b = k, _ = _a[_b], without = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        return without;
    }
}
exports.dissoc = dissoc;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlzc29jLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2Rpc3NvYy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7OztBQUVBLFNBQWdCLE1BQU0sQ0FBQyxNQUFXLEVBQUUsQ0FBTztJQUN2QyxJQUFJLE9BQU8sTUFBTSxLQUFLLFFBQVEsRUFBRTtRQUM1QixPQUFPLFNBQVMsYUFBYSxDQUFDLEdBQVE7WUFDbEMsT0FBTyxNQUFNLENBQUMsR0FBRyxFQUFFLE1BQU0sQ0FBQyxDQUFDO1FBQy9CLENBQVEsQ0FBQztLQUNaO1NBQU07UUFDSCxNQUE2QixLQUFBLE1BQU0sRUFBNUIsS0FBQyxDQUFFLEVBQUUsQ0FBQyxTQUFBLEVBQUssT0FBTyxjQUFuQix1Q0FBb0IsQ0FBUyxDQUFDO1FBQ3BDLE9BQU8sT0FBYyxDQUFDO0tBQ3pCO0FBQ0wsQ0FBQztBQVRELHdCQVNDIn0=